import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button, useDisclosure } from "@chakra-ui/react";
import { HelpModalContent } from "./HelpModalContent";
import { ModalWrapper } from "./ModalWrapper";

export const HelpModal: FC = () => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button fontSize="1rem" onClick={onOpen} variant="th-text-link">
        {t("onboarding.activate.page.help")}
      </Button>
      <ModalWrapper isOpen={isOpen} onClose={onClose}>
        <HelpModalContent onClose={onClose} />
      </ModalWrapper>
    </>
  );
};
